import { useGenericPromoteRole } from '@infuse/iam/role/mutations';
import { promoteTenantRole } from '@infuse/api/iam/tenant';

export const usePromoteTenantRole = () => {
  return useGenericPromoteRole({
    apiFn: promoteTenantRole
  });
};
